import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FiUploadCloud, FiX } from "react-icons/fi";
import { toast } from "react-toastify";

const UserForm = ({ initialData = null, onSubmit, onCancel }) => {
  const [form, setForm] = useState({
    fullName: "",
    phoneNumber: "",
    role: "User",
    file: null,
  });

  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    if (initialData) {
      setForm({
        fullName: initialData.fullName || "",
        phoneNumber: initialData.phoneNumber || "",
        role: initialData.role || "User",
        file: null,
      });
      setImagePreview(initialData.imageUrl || null);
    }
  }, [initialData]);

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024)
      return toast.error("Rasm 5MB dan kichik bo‘lsin");
    setForm((prev) => ({ ...prev, file }));
    setImagePreview(URL.createObjectURL(file));
  };

  const removeImage = (e) => {
    e.stopPropagation();
    setForm((prev) => ({ ...prev, file: null }));
    setImagePreview(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.fullName.trim() || !form.phoneNumber.trim()) {
      return toast.error("Ism va telefon majburiy");
    }
    onSubmit(form);
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      className="banner-form"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="form-grid">
        <div className="form-item">
          <label>F.I.O *</label>
          <input
            value={form.fullName}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, fullName: e.target.value }))
            }
            required
          />
        </div>

        <div className="form-item">
          <label>Telefon *</label>
          <input
            value={form.phoneNumber}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, phoneNumber: e.target.value }))
            }
            required
          />
        </div>

        <div className="form-item">
          <label>Role *</label>
          <select
            value={form.role}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, role: e.target.value }))
            }
            style={{
              padding: "12px 16px",
              borderRadius: "12px",
              border: "2px solid #e2e8f0",
              background: "white",
              fontSize: "15px",
            }}
          >
            <option value="User">User</option>
            <option value="Student">Student</option>
            <option value="Teacher">Teacher</option>
            <option value="Admin">Admin</option>
          </select>
        </div>

        <div className="form-item">
          <label>Rasm (ixtiyoriy)</label>
          <div className="image-upload-box">
            {imagePreview ? (
              <div className="image-preview-wrapper">
                <img
                  src={imagePreview}
                  alt="preview"
                  style={{
                    width: "100%",
                    height: 220,
                    objectFit: "cover",
                    borderRadius: 16,
                  }}
                />
                <motion.button
                  type="button"
                  className="remove-image-btn"
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={removeImage}
                >
                  <FiX size={20} />
                </motion.button>
              </div>
            ) : (
              <motion.label
                htmlFor="userImg"
                className="upload-area"
                whileHover={{ scale: 1.02 }}
              >
                <FiUploadCloud size={48} color="#00c853" />
                <p>Rasm yuklash</p>
                <span>JPG, PNG • Maks 5MB</span>
              </motion.label>
            )}
            <input
              id="userImg"
              type="file"
              accept="image/*"
              hidden
              onChange={handleImage}
            />
          </div>
        </div>

        <div className="form-buttons">
          <button type="submit" className="save">
            Saqlash
          </button>
          <button type="button" className="cancel" onClick={onCancel}>
            Bekor qilish
          </button>
        </div>
      </div>
    </motion.form>
  );
};

export default UserForm;
